import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import { addRemarksBillingTransaction } from "../../redux2/billing/billingSlice";

const AddRemarks = ({ billing }) => {
  const [openModal, setOpenModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    setRemark(e.target.value);
  };

  const handleClick = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setRemark("");
    setIsSubmitting(false);
  };

  const validateForm = () => {
    if (!remark.trim()) {
      toast.error("Remark is required");
      return false;
    }
    if (remark.trim().length < 5) {
      toast.error("Remark must be at least 5 characters long");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const data = {
        remark: remark.trim(),
        id: billing?._id,
      };

      await dispatch(addRemarksBillingTransaction(data));
      toast.success("Remark added successfully");
      handleClose();
    } catch (error) {
      console.error("Error adding remark:", error);
      toast.error(error?.message || "Failed to add remark");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="text-gray-700 transition-colors duration-200 cursor-pointer hover:text-blue-600"
        onClick={handleClick}
      >
        Add Remarks
      </div>

      <Modal
        show={openModal}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
      >
        <div className="bg-white rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">Add Remarks</h2>
            <button
              type="button"
              className="text-gray-400 transition-colors duration-200 hover:text-gray-600 disabled:opacity-50"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Remark <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="remark"
                  value={remark}
                  onChange={handleChange}
                  placeholder="Enter your remark here (minimum 5 characters)"
                  required
                  disabled={isSubmitting}
                  className="px-3 py-2 w-full rounded-md border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                  rows="4"
                  maxLength="500"
                />
                <div className="mt-1 text-xs text-gray-500">
                  {remark.length}/500 characters
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={handleClose}
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-md transition-colors duration-200 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting || !remark.trim()}
                  className="flex-1 px-4 py-2 text-white rounded-md transition-colors duration-200 bg-main-900 hover:bg-main-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "Adding..." : "Add Remark"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddRemarks;
